import WizardMain from '../Component/WizardMain';
import { connect } from 'react-redux';
import * as actions from "../../../Actions";

const mapStateToProps = (state) => {

  return {
    ZipcodeCheck: state.zipcodeCheck,
    PricingCalc: state.pricingCalc,
    PriceList: state.priceList,
    OrderSubmit: state.orderSubmit,
    email: state.user.email,
    inProgress: state.orderSubmit.inProgress,
    AccountInfo: state.AccountInfo,
    emailInUse: state.user.emailInUse,
    PreferredDays : state.PreferredDays,
    GoogleApi: state.GoogleApi,
    ResRegister: state.ResRegister,
  }
}

const mapDispatchToProps = {
  pricingCalculator: actions.pricingCalculator,
  checkZipCode: actions.checkZipCode,
  getPriceList: actions.getPriceList,
  placeOrder: actions.placeOrder,
  placeOrderInquery: actions.placeOrderInquery,
  registerUser: actions.registerUser,
  clearPricingCalc: actions.clearPricingCalc,
  getAccountInfo: actions.getAccountInfo,
  checkEmail: actions.checkEmail,
  getPreferredDays : actions.getPreferredDays,
  getGeocodeAddress: actions.getGeocodeAddress,
  resetGeocodeAddress: actions.resetGeocodeAddress,
  updateLead: actions.updateLead,
  getLeadById: actions.getLeadById,
  updateCustomerLastCompletedStep: actions.updateCustomerLastCompletedStep,
}

export default (connect(mapStateToProps, mapDispatchToProps)(WizardMain));